const page_404 = {
	description: "Die von Ihnen gesuchte Seite konnte nicht gefunden werden.",
	home_button: "Zur Homepage gehen",
	title: "404 Error",
};

export default page_404;
